export interface linksDetails {
  background: 'string';
  benefits: 'string';
  formats: 'string';
  questions: 'string';
  terms: 'string';
  video: 'string';
}
export interface CustomerLevel {
  position: number;
  name: string;
  targetAmount: number;
}

export interface CustomerActualLevel {
  position: number;
  name: string;
  targetAmount: number;
  progressPercentage: number;
  nextLevelName: string;
  amountToNext: number;
  monthlyAverageToNext: number;
}

export interface ActualState {
  case: number;
  description: string;
}

export interface SaleData {
  invocedTotalAmount: number;
  customerActualLevel: CustomerActualLevel;
  customerSaleLevels: CustomerLevel[];
  isFirstSemester: boolean;
  actualLevelName: string;
  actualState: ActualState;
}
export interface ProgressData {
  currentAmount: number;         // Monto actual facturado
  progressPercentage: number;    // Porcentaje de progreso general (hacia el 100%)
  avatarPosition: number;        // Posición del avatar en la barra de progreso
  animatedProgress: number;      // Valor animado para la barra (de 0 a progressPercentage)
  remainingForSilver: number;    // Monto restante para alcanzar el nivel Plata
  remainingForGold: number;      // Monto restante para alcanzar el nivel Oro
  silverProgress: number;    
  remainingForDiamond?: number;   // Porcentaje de avance hacia el nivel Plata
  monthlyAverage: number;        // Promedio mensual necesario para el próximo nivel
}
export interface AlliesProgressModalData {
  currentYear: number;
  mockProgressData: ProgressData; // Usa el tipo real en vez de `MockDataType` si lo tienes
  alignmentClass: string;
  saleData: SaleData; // Igual aquí
 activeCaseData:CaseData ;
}
export interface CaseData {
  case: number;
  title: string;
  description: string;
  buttonRedirect: string;
   icon: string;
}

export const totalCases: CaseData[] = [
  {
    case: 1,
    title: '',
    description: 'Acumula compras para mantener tu nivel actual o alcanzar uno superior.',
    buttonRedirect: 'Ver mis beneficios.',
    icon:'focus'
  },
  {
    case: 2,
    title: '',
    description: 'Si no llegas al mínimo, el próximo año podrías bajar de nivel.',
    buttonRedirect: '',
     icon:'icon-red-flag'
  },
  {
    case: 3,
    title: '',
    description: 'Los beneficios de este nivel serán tuyos un año más.',
    buttonRedirect: 'Ver mis beneficios.',
     icon:'icon-like'
  },
  {
    case: 4,
    title: '',
    description: 'Recibirás los beneficios de tu nuevo nivel durante el próximo año.',
    buttonRedirect: '',
     icon:'icon-like'
  },
  {
    case: 5,
    title: '',
    description: 'Suma compras y desbloquea los beneficios del siguiente nivel.',
    buttonRedirect: 'Ver beneficios.',
     icon:'focus'
  },
  {
    case: 6,
    title: '',
    description: 'Tu esfuerzo constante ha dado frutos. Has llegado a la cima y disfrutarás los mejores beneficios durante todo el próximo año.',
    buttonRedirect: '',
     icon:'medal-diamond'
  }
];
export interface  MonthData {
  name: string;
  amount: string; // podría ser string o number
}

export interface  QuarterData {
  trimestre: number;
  total: number;
  months: MonthData[];
}

export type BillingData = QuarterData[];